/**
 * Open a PDF/document URL in a new tab.
 * Supports CMS shape { url } and legacy shape { path }.
 * @param {string|Object} document - URL string or object with url/path property
 */
export const openPDF = document => {
  const path =
    typeof document === 'string' ? document : document?.url || document?.path;

  if (!path) return;

  // Use _blank without window features so modern browsers open a new tab
  // (a features string triggers popup blocking in some browsers).
  let opened = null;
  try {
    opened = window.open(path, '_blank');
  } catch {
    opened = null;
  }

  // Popup-blocker fallback: navigate using an anchor click.
  if (!opened) {
    const anchor = document.createElement('a');
    anchor.href = path;
    anchor.target = '_blank';
    anchor.rel = 'noopener noreferrer';
    anchor.click();
  }
};
